import React from "react";
import { useHelpVisibility } from "../hooks/useHelpVisibility";

/**
 * Lien « Centre d'aide » dans le footer — masqué tant que l'admin ne l'a
 * pas activé via le toggle Administrateur → Guides PDF.
 */
export default function FooterHelpLink() {
  const { visible } = useHelpVisibility();
  if (!visible) return null;
  return (
    <a href="/help" className="hover:text-ink" data-testid="footer-help-link">
      Centre d'aide
    </a>
  );
}
